import { render, staticRenderFns } from "./MainCategoryCard.vue?vue&type=template&id=59d27ae9&scoped=true"
import script from "./MainCategoryCard.vue?vue&type=script&lang=js"
export * from "./MainCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryCard.vue?vue&type=style&index=0&id=59d27ae9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d27ae9",
  null
  
)

export default component.exports